import React, { useEffect, useState } from "react";
import BookedRideCard from "./BookedRideCard";
import { fetchMyRequests } from "../utils/api"; 
import AdBanner from "./ads/AdBanner"; // Ensure this path is correct
import "../css/bookedrides.css"; 

export default function BookedRides({ user }) {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const userId = user?.id || user?._id;

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("travelo_token");
      if (!userId || !token) {
        setRides([]);
        setLoading(false);
        return;
      }

      const requests = await fetchMyRequests(token);
      const list = Array.isArray(requests) ? requests : requests.requests || requests || [];

      const mapped = list
        .map((req) => {
          const rideObj = req?.ride || req?.rideId || req?.ride_data || req?.rideInfo || null;
          if (!rideObj) return null;

          return {
            ride: rideObj,
            request: req,
            sortTime: new Date(req?.createdAt || rideObj?.createdAt || rideObj?.date).getTime()
          };
        })
        .filter(Boolean)
        .sort((a, b) => b.sortTime - a.sortTime);

      setRides(mapped);
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Could not load your bookings.");
      setRides([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [userId]);

  return (
    <div className="br-wrapper">
      <div className="br-container fade-in">
        
        {/* Header Section */}
        <div className="br-header-row">
          <h2 className="br-title">📘 My Bookings</h2>
          <span className="br-booking-count">{rides.length} Rides</span>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="br-state-box br-loading">
            <div className="br-spinner"></div>
            <p>Syncing your bookings...</p>
          </div>
        ) 
        
        /* Error State */
        : error ? (
          <div className="br-state-box br-error">
            <span className="br-emoji">⚠️</span>
            <p>{error}</p>
            <button className="br-retry-btn" onClick={load}>Try Again</button>
          </div>
        ) 
        
        /* Empty State (With Ad) */
        : rides.length === 0 ? (
          <div className="br-state-box br-empty">
            <span className="br-emoji">🎟️</span>
            <h3>No Rides Booked Yet</h3>
            <p>You haven't booked any rides. Find a ride to get started!</p>
            <button className="br-find-btn" onClick={() => window.location.href="/"}>Find a Ride</button>
            
            <div className="br-empty-ad">
              <span className="br-ad-label">Sponsored</span>
              <AdBanner type="inline" />
            </div>
          </div>
        ) 
        
        /* Populated Grid */
        : (
          <div className="br-grid">
            {rides.map((item, idx) => {
              const ride = item.ride;
              const request = item.request;
              const key = request?._id || ride?._id || `booking-${idx}`;
              
              return (
                <React.Fragment key={key}>
                  <BookedRideCard
                    ride={ride}
                    request={request}
                    user={user}
                    onRefresh={load} 
                  />
                  
                  {/* IN-FEED AD: Shows after every 4th ride */}
                  {(idx + 1) % 4 === 0 && (
                    <div className="br-infeed-ad">
                      <span className="br-ad-label">Sponsored</span>
                      <AdBanner type="inline" />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}